document.addEventListener("DOMContentLoaded", function() {
    // Select your sticky header
    var header = document.querySelector(".header-sticky");
    var className = "scroll-active";

    if (!header) return; // exit if header not found

    // Function to toggle class
    function toggleScrollClass() {
        if (window.scrollY > 0) {
            header.classList.add(className);
        } else {
            header.classList.remove(className);
        }
    }

    // Listen to scroll
    window.addEventListener("scroll", toggleScrollClass);

    // Trigger once on page load in case already scrolled
    toggleScrollClass();
});

